import { render } from "./TableActions.vue?vue&type=template&id=dd1ee090"
import script from "./TableActions.vue?vue&type=script&lang=js"
export * from "./TableActions.vue?vue&type=script&lang=js"

import "./TableActions.vue?vue&type=style&index=0&id=dd1ee090&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__